import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config.json";
import AuthService from "../../services/authService";
import { Box, Typography, Button, CircularProgress } from "@mui/material";

const PaypalSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [status, setStatus] = useState("loading"); // loading | success | error
    const [message, setMessage] = useState("");

    useEffect(() => {
        const runCapture = async () => {
            try {
                const orderId = searchParams.get("token");

                if (!orderId) {
                    setStatus("error");
                    setMessage("Missing PayPal token in URL.");
                    return;
                }

                const jwt = AuthService.getJwt();
                if (!jwt) {
                    setStatus("error");
                    setMessage("You must login again before capturing payment.");
                    return;
                }

                const res = await axios.post(
                    config.apiEndPoint + "paypal/capture-order",
                    { orderId },
                    {
                        headers: {
                            Authorization: `Bearer ${jwt}`,
                        },
                    }
                );

                console.log("Capture result:", res.data);
                setStatus("success");
                setMessage(
                    `Payment completed successfully for item #${res.data.itemId} – Amount: ${res.data.amount} ${res.data.currency}`
                );
            } catch (err) {
                console.error(err);
                let errMsg =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    "Error while capturing payment.";
                setStatus("error");
                setMessage(errMsg.toString());
            }
        };

        runCapture();
    }, [searchParams]);

    return (
        <Box
            sx={{
                minHeight: "80vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                textAlign: "center",
                gap: 2,
            }}
        >
            {status === "loading" && (
                <>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>
                        Processing your payment, please wait...
                    </Typography>
                </>
            )}

            {status === "success" && (
                <>
                    <Typography variant="h4" sx={{ color: "gold", mb: 2 }}>
                        Payment Successful 🎉
                    </Typography>
                    <Typography sx={{ mb: 3 }}>{message}</Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate("/store")}
                        sx={{
                            backgroundColor: "gold",
                            color: "#0a0a1a",
                            fontWeight: 700,
                            "&:hover": { backgroundColor: "#ffda47" },
                        }}
                    >
                        Back to Store
                    </Button>
                </>
            )}

            {status === "error" && (
                <>
                    <Typography variant="h4" sx={{ color: "#ff6b6b", mb: 2 }}>
                        Payment Failed
                    </Typography>
                    <Typography sx={{ mb: 3 }}>{message}</Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate("/store")}
                        sx={{
                            backgroundColor: "gold",
                            color: "#0a0a1a",
                            fontWeight: 700,
                            "&:hover": { backgroundColor: "#ffda47" },
                        }}
                    >
                        Back to Store
                    </Button>
                </>
            )}
        </Box>
    );
};

export default PaypalSuccess;
